import React from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Nav, { NavItem } from 'tbk-components/src/components/Nav';
import MMNav, { MMNavItem } from '../MegaMenus/Nav';

// Represents a link in the language selector drop-down
export type LanguageNavItem = {
	href: string;
	label: string;
	target?: string;
	icon?: string;
	code?: string;
	locale?: string;
};

export interface IFooterTopProps extends IBaseElementProps {
	logo?: IImage;
	logoURL?: string;
	businessUnitURL?: ILink;
	addressTitle?: string;
	address?: string;
	addressUrl?: ILink;
	activeLanguage?: LanguageNavItem;
	languages?: LanguageNavItem[];
	businessUnitSelectionNav?: MMNavItem[];
	callToAction?: ILink;
	callToActionColor?:
		| 'Light'
		| 'Dark'
		| 'Primary'
		| 'ITCS Primary'
		| 'ITCS Accent';
	footerTopNav?: NavItem[];
}

const FooterTop: React.FC<IFooterTopProps> = ({
	className,
	classNames = [],
	logo,
	logoURL,
	businessUnitURL,
	addressTitle,
	address,
	addressUrl,
	activeLanguage,
	languages,
	businessUnitSelectionNav,
	callToAction,
	callToActionColor = 'Primary',
	footerTopNav,
}) => (
	<div
		className={
			className || cn('calian-footer__top container-fluid', ...classNames)
		}
	>
		<div className="calian-footer__top--content container">
			<div className="calian-footer__top--navbar navbar">
				<div className="calian-footer__top--navbar-container container-fluid">
					<div className="calian-footer__top--navbar-left">
						{!footerTopNav && (
							<>
								{logo && logoURL && (
									<a
										className="calian-footer__top--navbar-brand navbar-brand"
										href={logoURL}
									>
										<Image
											{...logo}
											className="img-fluid"
										/>
									</a>
								)}
								{businessUnitURL?.label && businessUnitURL?.href && (
									<p className="calian-footer__top--business-unit">
										<a href={businessUnitURL.href}>
											{businessUnitURL.label}
										</a>
									</p>
								)}
								<div className="calian-footer__top--address-container">
									{addressUrl && (
										<a
											className="calian-footer__address-link"
											href={addressUrl.href}
											target={addressUrl.target}
										>
											{addressTitle && (
												<p className="calian-footer__address-title">
													{addressTitle}
												</p>
											)}
											{address && (
												<p className="calian-footer__address">
													{address}
												</p>
											)}
										</a>
									)}
									{!addressUrl && (
										<>
											{addressTitle && (
												<p className="calian-footer__address-title">
													{addressTitle}
												</p>
											)}
											{address && (
												<p className="calian-footer__address">
													{address}
												</p>
											)}
										</>
									)}
								</div>
							</>
						)}

						{footerTopNav && footerTopNav.length > 0 && (
							<Nav
								navItems={footerTopNav}
								collapseEnabled={false}
								dropdownEnabled={true}
								classNames={['calian-footer__top-nav']}
							/>
						)}
					</div>
					<div className="calian-footer__top--navbar-right">
						{activeLanguage && (
							<ul className="nav justify-content-start calian-footer__language-select-nav">
								<li className="nav-item dropdown">
									<a
										className="nav-link dropdown-toggle"
										href="#"
										aria-expanded="false"
										role="button"
										data-bs-toggle="dropdown"
										data-bs-auto-close="true"
									>
										{activeLanguage.label}
									</a>
									{languages && languages.length > 0 && (
										<ul className="dropdown-menu">
											{languages.map(
												(languageNavItem, index) => {
													return (
														<li
															key={
																languageNavItem.code +
																'-' +
																index
															}
														>
															<a
																className="dropdown-item"
																href={
																	languageNavItem.href
																}
																target={
																	languageNavItem.target
																		? languageNavItem.target
																		: '_self'
																}
															>
																{
																	languageNavItem.label
																}
															</a>
														</li>
													);
												},
											)}
										</ul>
									)}
								</li>
							</ul>
						)}
						{businessUnitSelectionNav && (
							<MMNav
								navItems={businessUnitSelectionNav}
								collapseEnabled={false}
								dropdownEnabled={true}
								classNames={[
									'calian-footer__business-unit-select-nav',
								]}
							/>
						)}
						{callToAction && (
							<Button
								className={cn(
									'calian-footer__cta-btn btn btn-sm',
									{
										[`btn-${kebabCase(callToActionColor)}`]:
											callToActionColor,
									},
								)}
								{...callToAction}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default FooterTop;
